/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Intake_Progress_A11yInputs */

const en_us2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Question ${i?.index} of ${i?.total}`)
};

const pt_br2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pergunta ${i?.index} de ${i?.total}`)
};

const es_419_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pregunta ${i?.index} de ${i?.total}`)
};

const pt_pt2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pergunta ${i?.index} de ${i?.total}`)
};

const fr_fr2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Question ${i?.index} sur ${i?.total}`)
};

const de_de2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frage ${i?.index} von ${i?.total}`)
};

const it_it2_intake_progress_a11y = /** @type {(inputs: Intake_Progress_A11yInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domanda ${i?.index} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Question {index} of {total}" |
*
* @param {Intake_Progress_A11yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_progress_a11y = /** @type {((inputs: Intake_Progress_A11yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Progress_A11yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_progress_a11y(inputs)
	if (locale === "es-419") return es_419_intake_progress_a11y(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_progress_a11y(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_progress_a11y(inputs)
	if (locale === "de-DE") return de_de2_intake_progress_a11y(inputs)
	if (locale === "it-IT") return it_it2_intake_progress_a11y(inputs)
	return en_us2_intake_progress_a11y(inputs)
});
export { intake_progress_a11y as "intake.progress_a11y" }